import React from 'react';
import classNames from 'classnames';
import usePreviousMatches from '@amf/shared/data/hooks/usePreviousMatches';
import { MatchListItemFragment } from '@amf/shared/types/graphql';
import { useTranslate } from '@tolgee/react';
import Loader from '@amf/shared/components/utils/Loader';

import MatchTable from './MatchTable';

interface MatchPreviousListProps {
  match: MatchListItemFragment;
  prefixes: { match: string };
  title?: string;
  center?: boolean;
}

function MatchPreviousList({ match, prefixes, title, center }: MatchPreviousListProps) {
  const { t } = useTranslate();
  const { matches, loadMore, loading, isLoadMore } = usePreviousMatches(match.id);

  if (!loading && matches.length === 0) return null;
  return (
    <div className='MatchPreviousList'>
      {title && (
        <h2
          className={classNames('MatchPreviousList__title', {
            'MatchPreviousList__title--center': center,
          })}
        >
          {title}
        </h2>
      )}
      {loading && <Loader size='small'>{t('loading')}</Loader>}
      <div className='MatchPreviousList__matches'>
        <MatchTable matches={matches} matchPrefix={prefixes.match} noRounds />
      </div>
      {isLoadMore && <div className='MatchPreviousList__pagination'>{loadMore()}</div>}
    </div>
  );
}

export default MatchPreviousList;
